<template>
  <div class="live-sLive">
    <div class="banner cooperation-banner live-banner">
      <div class="w1200">
        <h1 class="title">直播</h1>
        <p class="desc">轻量型的个性化课堂</p>
        <a href="/" target="_blank" class="btn proxyBtn">立即创建直播课堂</a>
      </div>
    </div>
    <div class="lz-live-functional-introduce">
      <div class="live-functional-info">
        <div class="w1200">
          <div class="live-introduce-detail text-in-left-style">
            <div class="introduce-text">
              <div class="introduce-title">语音直播/视频直播/PPT课件直播</div>
              <div class="introduce-tips">
                支持语音、实时视频、录播视频、PPT课件、图片等多种形式的的直播教学，搭配语音讲解、白板互动，满足多种个性化教学场景
              </div>
            </div>
            <img
              class="introduce-img0 introduce-img"
              :src="require('@/assets/images/lSlive1' + getImgSuffix + '.png')"
              alt=""
            />
          </div>
        </div>
        <img
          v-if="$store.state.sceneClassName !== 'app'"
          class="live-bg-img0"
          :src="require('@/assets/images/lSlive2.png')"
          alt=""
        />
      </div>
      <div class="live-functional-info gray-bg-color">
        <div class="w1200">
          <div class="live-introduce-detail text-in-right-style">
            <div class="introduce-text">
              <div class="introduce-title">横屏直播/竖屏直播</div>
              <div class="introduce-tips">
                创建直播课程时可选择横屏直播/竖屏直播。横屏直播适用于知识讲解类直播，竖屏直播适用于泛娱乐化教学、营销带货类直播
              </div>
            </div>
            <img
              class="introduce-img1 introduce-img"
              :src="require('@/assets/images/lSlive3.png')"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="live-functional-info">
        <div class="w1200">
          <div class="live-introduce-detail text-in-left-style">
            <div class="introduce-text">
              <div class="introduce-title">多样化直播终端</div>
              <div class="introduce-tips">
                支持 PC客户端 / App / 小程序 /网页端 /微信H5/
                OBS等各种直播终端，方便灵活选择
              </div>
            </div>
            <img
              class="introduce-img2 introduce-img"
              :src="require('@/assets/images/lSlive4.png')"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="live-functional-info gray-bg-color">
        <div class="w1200">
          <div class="live-introduce-detail text-in-right-style">
            <div class="introduce-text">
              <div class="introduce-title">丰富教学方式</div>
              <div class="introduce-tips">
                支持讲师上镜 / 桌面屏幕共享 / 课件上屏 / 多讲师同屏 ，支持PPT /
                录制视频 / 图片放映+语音讲解。多种人性化教学方式，可自由挑选
              </div>
            </div>
            <img
              class="introduce-img3 introduce-img"
              :src="require('@/assets/images/lSlive5.png')"
              alt=""
            />
          </div>
        </div>
        <img
          class="live-bg-img4"
          :src="require('@/assets/images/lSlive6.png')"
          alt=""
        />
      </div>
    </div>
    <v-free title="现在加入，立享新商家专享优惠礼包" href="/"></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free.vue';

export default {
  components: {
    'v-free': Free
  },
  computed: {
    getImgSuffix() {
      if (this.$store.state.sceneClassName === 'app') {
        return '_app';
      }
      return '';
    }
  }
};
</script>

<style lang="scss">
.live-sLive {
  .cooperation-banner {
    background-image: url('~@/assets/images/lSlive7.png');
  }
}
</style>
